import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { isCallConnected } from '../model';
import { useSelector } from '../store';
import { selectCall } from '../store/reducers/janus';
import css from './Video.module.scss';

type Props = {
    className?: string
    remoteVideoClassName?: string
    localVideoClassName?: string
}

export default function Video({ className, remoteVideoClassName, localVideoClassName }: Props) {
    const call = useSelector(selectCall)

    const remoteVideoRef = useCallback((element: HTMLVideoElement | null) => {
        if (!element) { return }
        element.srcObject = call?.remoteStream ?? null
    }, [call?.remoteStream])

    const localVideoRef = useCallback((element: HTMLVideoElement | null) => {
        if (!element) { return }
        element.srcObject = call?.localStream ?? null
    }, [call?.localStream])

    return <div className={classNames(css.videoContainer, className)}>
        {call?.hasRemoteVideo && isCallConnected(call) && <video className={classNames(css.remote, remoteVideoClassName)} autoPlay ref={remoteVideoRef} muted />}
        {call?.hasLocalVideo && isCallConnected(call) && <video className={classNames(css.local, localVideoClassName)} autoPlay ref={localVideoRef} muted />}
    </div>
}
